import React from 'react';
import Hero from '../../components/ui/Hero';
import { Music } from 'lucide-react';

const SongsPage = () => {
  return (
    <div>
      <Hero
        title="Songs & Lyric Videos"
        description="Coming Soon - Enjoy animatronic show tunes and performances!"
        compact
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <Music className="w-16 h-16 text-brand mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-content-primary mb-4">
            Animatronic Show Tunes Coming Soon!
          </h2>
          <p className="text-content-secondary max-w-2xl mx-auto">
            Get ready to experience your favorite animatronic performances through music! 
            We're preparing a collection of show tunes and lyric videos from beloved animatronic shows.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SongsPage;